"use client"

export default function Error() {
  return null
}
